export default __webpack_public_path__ + "static/media/17t.0fc1e6d4.jpg";